import { useNotification } from "components/Notification/useAddNotification";

export const useRegisterNotification = () => {
  const { addNotification } = useNotification();
  const notificationTitle = "Rejestracja";

  const showSuccessNotification = () =>
    addNotification({
      title: notificationTitle,
      description:
        "Na podany email został wysłany link potwierdzający rejestrację.",
      type: "success",
    });

  const showErrorNotification = (errorMessage?: string) =>
    addNotification({
      title: notificationTitle,
      description: errorMessage ?? "Wysłanie formularza nie powiodło się.",
      type: "error",
    });

  return { showSuccessNotification, showErrorNotification };
};
